import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { groupBy }  from 'lodash';

import RootRef from '@material-ui/core/RootRef';
import { submit, change } from 'redux-form';
import Typography from '@material-ui/core/Typography';
import { withStyles } from '@material-ui/core/styles';

import Progress from 'components/common/Progress';
import Dialog, {
  DialogActions,
  DialogContent,
  DialogTitle,
} from 'components/common/Dialog';
import Button from 'components/common/Button';

import { fetchPatientMessages, clearPatientMessages } from 'redux/modules/patientsMessages';

import throttle from 'utils/throttle';
import formatUtcToLocalDate from 'utils/formatUtcToLocalDate';

import dateFormat from 'config/dateFormat';
import timeFormat from 'config/timeFormat';
import timeDateFormat from 'config/timeDateFormat';

import NotificationsDialogItem from './NotificationsDialogItem';
import NotificationsDialogForm from './NotificationsDialogForm';
import NotificationsDialogTemplates from './NotificationsDialogTemplates';

const styles = () => ({
  notificationsList: {
    paddingTop: 8,
    boxSizing: 'border-box',
    display: 'flex',
    flexDirection: 'column-reverse',
  },
  notificationsGroup: {
    display: 'flex',
    flexDirection: 'column-reverse',
  },
  dialogActions: {
    alignItems: 'flex-end',
  },
  button: {
    marginBottom: 6,
  },
});

class NotificationsDialog extends Component {
  constructor(props) {
    super(props);

    this.state = {
      triggerLoading: true,
      scrollHeight: 0,
      clientHeight: 0,
      scrollMaxHeightDecrease: 0,
    };

    this.onRequest = this.onRequest.bind(this);
    this.onDialogEnter = this.onDialogEnter.bind(this);
    this.onDialogExited = this.onDialogExited.bind(this);
    this.onFormChange = this.onFormChange.bind(this);

    this.onRequest = throttle(this.onRequest);
  }

  componentWillReceiveProps(nextProps) {
    const { open, count, loading, patientsMessages } = this.props;
    const newState = {};
    if (count === 0 || !open) {
      newState.triggerLoading = true;
    } else {
      newState.triggerLoading = false;
    }
    if ((loading === 1 && nextProps.loading === 0) || patientsMessages.length < nextProps.patientsMessages.length) {
      setTimeout(() => {
        if (this.scrollbarsRef) {
          this.scrollbarsRef.scrollToBottom();
          if (this.dialogActionsRef) {
            this.setState({
              scrollMaxHeightDecrease: this.dialogActionsRef.getBoundingClientRect().height - 65,
            });
          }
        }
      }, 200);
    }
    this.setState(newState);
  }

  onRequest() {
    const { actions } = this.props;
    const { triggerLoading } = this.state;
    actions.fetchPatientMessages({
      filters: [
        {
          name: 'Patient ID',
          operation: 'eq',
          val: this.props['Record Number'],
        },
      ],
      triggerLoading,
    });
  }

  onDialogEnter() {
    this.props.actions.clearPatientMessages();
    this.onRequest();
  }

  onDialogExited() {
    this.setState({
      triggerLoading: true,
    });
  }

  onFormChange(values, dispatch, props, prevValues) {
    if (values.Message && values.Message !== prevValues.Message && this.dialogActionsRef) {
      this.setState({
        scrollMaxHeightDecrease: this.dialogActionsRef.getBoundingClientRect().height - 65,
      });
    }
  }

  render() {
    const {
      open,
      loading,
      onClose,
      business,
      actions,
      account,
      onDocumentView,
      classes,
    } = this.props;
    const { clientHeight, scrollMaxHeightDecrease } = this.state;
    let { patientsMessages } = this.props;
    patientsMessages = patientsMessages.map(item => ({
      ...item,
      Date: formatUtcToLocalDate(
        item['Date of Creation'],
        timeDateFormat,
        dateFormat,
        business['Company Address']['Time Zone'],
        business['Company Address']['Observes Daylight Saving'],
      ),
      Time: formatUtcToLocalDate(
        item['Date of Creation'],
        timeDateFormat,
        timeFormat,
        business['Company Address']['Time Zone'],
        business['Company Address']['Observes Daylight Saving'],
      ),
    }));
    const patientsMessagesByDate = groupBy(patientsMessages, 'Date');
    return (
      <Dialog
        open={open}
        onClose={onClose}
        onEnter={this.onDialogEnter}
        onExited={this.onDialogExited}
        maxWidth="md"
      >
        <DialogTitle onCloseClick={onClose}>
          <Typography
            variant="title"
            color="secondary"
            align="center"
          >
            {this.props['First Name']} {this.props['Last Name']}: SMS Notifications
          </Typography>
        </DialogTitle>
        <DialogContent
          withScrollbars
          disableGutters
          fromBottom
          fullHeight
          scrollbarsRef={(scrollbarsRef) => {
            this.scrollbarsRef = scrollbarsRef;
          }}
          scrollMaxHeightDecrease={scrollMaxHeightDecrease}
        >
          {(loading > 0) ? (
            <Progress />
          ) : (
            <div
              className={classes.notificationsList}
              style={{
                minHeight: `${clientHeight}px`,
              }}
            >
              {Object.keys(patientsMessagesByDate).map(date => (
                <div className={classes.notificationsGroup} key={date}>
                  {patientsMessagesByDate[date].map(item => (
                    <NotificationsDialogItem
                      key={item.ID}
                      {...item}
                      {...{'First Name': this.props['First Name'] }}
                      {...{'Last Name': this.props['Last Name'] }}
                      account={account}
                      onDocumentView={onDocumentView}
                    />
                  ))}
                  <Typography variant="caption" align="center" gutterBottom>
                    {date}
                  </Typography>
                </div>
              ))}             
            </div>
          )}
          
        </DialogContent>
        <RootRef
          rootRef={(dialogActionsRef) => {
            this.dialogActionsRef = dialogActionsRef;
          }}
        >
          <DialogActions className={classes.dialogActions}>
            <NotificationsDialogForm
              form={`${this.props['Record Number']}-messageCreateForm`}
              onSubmitSuccess={(values, dispatch, props) => {
                props.reset();
                this.scrollbarsRef.scrollToBottom();
              }}
              {...{ 'Record Number': this.props['Record Number'] }}
              account={account}
              onChange={this.onFormChange}
            />
            <NotificationsDialogTemplates
              onTemplateSelect={(template) => {
                actions.change(`${this.props['Record Number']}-messageCreateForm`, 'Message', template);
              }}
              account={account}
            />
            <Button
              className={classes.button}
              onClick={() => {
                actions.submit(`${this.props['Record Number']}-messageCreateForm`);
              }}
              variant="raised"
              color="primary"
            >
              Send
            </Button>
          </DialogActions>
        </RootRef>
      </Dialog>
    );
  }
}

NotificationsDialog.propTypes = {
  'Record Number': PropTypes.number.isRequired,
  patientsMessages: PropTypes.arrayOf(PropTypes.shape({
    ID: PropTypes.number.isRequired,
  })).isRequired,
  open: PropTypes.bool,
  onClose: PropTypes.func,
  count: PropTypes.number.isRequired,
  loading: PropTypes.number.isRequired,
  actions: PropTypes.shape({
    fetchPatientMessages: PropTypes.func.isRequired,
    clearPatientMessages: PropTypes.func.isRequired,
  }).isRequired,
  business: PropTypes.shape({
    ID: PropTypes.number,
  }),
  account: PropTypes.shape({
    ID: PropTypes.number,
  }),
  onDocumentView: PropTypes.func,
};

NotificationsDialog.defaultProps = {
  open: false,
  onClose: () => {},
  business: {},
  onDocumentView: () => {},
};

const mapStateToProps = store => ({
  patientsMessages: store.patientsMessages.data,
  count: store.patientsMessages.count,
  loading: store.patientsMessages.loading,
  account: store.account,
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({
    fetchPatientMessages, clearPatientMessages, submit, change,
  }, dispatch),
});


export default connect(mapStateToProps, mapDispatchToProps)(
  withStyles(styles)(NotificationsDialog),
);



// WEBPACK FOOTER //
// ./src/components/patient/NotificationsDialog/NotificationsDialog.js